import { restClient } from '@/Core'

import { toUploadSession } from '../Helpers/diskResponse'

import type { DiskUploadConflict, DiskUploadSession } from '../Contracts/DiskUpload'

export interface StartDiskUploadParams {
    parent: string
    name: string
    size: number
    conflict: DiskUploadConflict
    relativePath?: string
    sha256?: string | null
    signal?: AbortSignal
}

/**
 * Почати завантаження шматками: `POST /services/disk/uploads`. Бек одразу
 * резервує квоту (нестача — 422 з поясненням) і з `conflict=fail` перевіряє
 * назву; у відповіді — розмір шматка й отримані номери.
 */
export const StartDiskUploadTask = async ({
    parent,
    name,
    size,
    conflict,
    relativePath,
    sha256,
    signal,
}: StartDiskUploadParams): Promise<DiskUploadSession> => {
    const json: Record<string, string | number> = { parent, name, size, conflict }
    if (relativePath) json['relativePath'] = relativePath
    if (sha256) json['sha256'] = sha256

    const response = (await restClient.post('/services/disk/uploads', { json, ...(signal ? { signal } : {}) })) as unknown

    return toUploadSession(response)
}
